var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParkingShared({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 320,
    viewBox: "30 30 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M160.441 275.705c-64.147 0-116.152-52.004-116.152-116.15 0-64.146 52.005-116.15 116.152-116.15 64.147 0 116.152 52.004 116.152 116.15 0 64.146-52.005 116.15-116.152 116.15z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(98 -22)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M39.415 201v-54.59h23.424c8.76 0 16.533-1.137 23.323-3.412 6.79-2.274 12.476-5.448 17.06-9.522 4.583-4.074 8.062-8.929 10.439-14.564 2.376-5.636 3.564-11.848 3.564-18.638 0-6.858-1.103-13.07-3.31-18.638-2.206-5.568-5.55-10.32-10.032-14.259-4.48-3.938-10.133-6.976-16.957-9.115-6.824-2.139-14.853-3.208-24.087-3.208H19.76V201h19.656zm23.424-70.274H39.415v-60.09h23.424c11.61 0 20.285 2.615 26.022 7.843 5.737 5.228 8.606 12.493 8.606 21.795 0 4.481-.747 8.589-2.24 12.323-1.494 3.735-3.701 6.943-6.62 9.625-2.92 2.682-6.536 4.77-10.847 6.263-4.312 1.494-9.285 2.24-14.92 2.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M53 245.498C53 255.164 45.164 263 35.498 263 25.836 263 18 255.164 18 245.498 18 235.836 25.836 228 35.498 228 45.164 228 53 235.836 53 245.498M125 206.5c0 9.665-7.836 17.5-17.502 17.5C97.832 224 90 216.165 90 206.5s7.832-17.5 17.498-17.5S125 196.835 125 206.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    x2: 108,
    y1: 245,
    y2: 208,
    stroke: "#FEFEFE",
    strokeWidth: 13.284
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    x2: 107,
    y1: 248,
    y2: 280,
    stroke: "#FEFEFE",
    strokeWidth: 13.284
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M125 280.5c0 9.665-7.836 17.5-17.502 17.5C97.832 298 90 290.165 90 280.5s7.832-17.5 17.498-17.5S125 270.835 125 280.5"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingShared);
export default __webpack_public_path__ + "static/media/parkingShared.e7895af1.svg";
export { ForwardRef as ReactComponent };